import { attr, css, FASTElement, html, ref } from "@microsoft/fast-element";
import { getToken } from "../../design-tokens";
import { jsonConverter } from "../../value-converters/json-value-converter";
import { NatGenDesignSystem } from "../../natgen-design-system";
import { NatGenDialog } from "../dialog/dialog";
import { NatGenPopper, type PopperPlacement } from "../popper/popper";
import { keyEscape } from "@microsoft/fast-web-utilities";

/**
 * @element natgen-tooltip
 */
export class NatGenTooltip extends FASTElement {
    @attr
    placement: PopperPlacement = 'auto';

    @attr({ converter: jsonConverter })
    offset: [number, number];

    @attr({ mode: 'boolean' })
    flip: boolean = true;

    container: NatGenPopper;
    dialog: NatGenDialog;

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("keydown", this.handleDocumentKeydown);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("keydown", this.handleDocumentKeydown);
    }

    private handleDocumentKeydown = (e: KeyboardEvent): void => {
        if (e.key == keyEscape && !e.defaultPrevented && this.container.show) {
            this.container.show = false;
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    };
}

export const natGenTooltipDefinition = NatGenTooltip.compose({
    name: `${NatGenDesignSystem.prefix}-tooltip`,
    styles: css`
        .tooltip {
            vertical-align: middle;
            color: ${getToken('color-primary-base')};
        }

        natgen-popper {
            z-index: 1;
            text-align: left;
        }

        .control {
            width: max-content;
            max-width: min(90vw, calc(${getToken('space-breakpoint-small')} * 1px));
        }
    `,
    template: html<NatGenTooltip>`
        <template>
            <natgen-button class="tooltip" variant="link-light" aria-label="toggle tooltip" >
                <natgen-icon name="tooltip" size="5"></natgen-icon>
            </natgen-button>

            <natgen-popper ${ref('container')} selector=".tooltip" offset="${x => JSON.stringify(x.offset)}" placement="${x => x.placement}" ?flip="${x => x.flip}" tabindex="0">
                <natgen-inner-dialog no-focus-trap class="control" part="control">
                    <slot></slot>
                </natgen-inner-dialog>
            </natgen-popper>
        </template>
    `
});
